function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import __ from 'ramda/src/__';
import clone from 'ramda/src/clone';
import isNil from 'ramda/src/isNil';
import pathOr from 'ramda/src/pathOr';
import reject from 'ramda/src/reject';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import i18n from 'invision-core/src/components/i18n/i18n';
import { subscriberOrderTypeEnum } from 'invision-core/src/utilities/subscriber.order.type.enum';
import { MetadataCodeLoadedSelector, MetadataCodeTypeDictionarySelector, MetadataCodeTypeSelector, MetadataOptionsForCodeValuesSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { CurrentBusinessUnitCurrencyCodeSelector, IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { fetchAddressCountryTypes, fetchAddressStateTypes, fetchCreditCardTypes, fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import CustomerCareKeys from '../../../../locales/keys';
import cloneDeep from 'lodash/cloneDeep';
import { BILLING_EFFECTIVE_DATE_ORDER_OPTIONS, DOWN_PAYMENT_TYPE, INVOICE_TIMING_CONSTANTS, ORDER_SCENARIOS, ORDER_TYPE_CODE, REASON_ADDITIONAL_PROPERTY_KEYS, SCHEDULED_ORDER_OPTIONS } from '../../../../customercare.constants';
import { BillingEffectiveDateOptionsSelector, BillingEffectiveDateSettingsSelector, IsQuotingOfferSelector, IsSubmittingOrderSelector, OfferingOrderCheckoutPageEditFormSelector, OfferingOrderOffCycleAlignmentSelector, SelectedOrderExecutionOptionsSelector, SelectedShippingAddressAndMethodSelector, UpdatedShippingAddressSelector } from '../../../../reducers/selectors/offering.order.selectors';
import { CartContainsOfferWithBillerRuleCycleLevelOtherThanItemSelector, GetMaxDateForFutureDatedOrder, IsFutureDatedOrderAllowedInBunt, SelectedOfferChangesEffectiveSelector, SelectedOfferExternalContractIdSelector, SelectedOfferPurchaseOrderNumberSelector, ShoppingCartSelector } from '../../../../reducers/selectors/selected.offering.order.selectors';
import { BLANK_BILLING_ADDRESS_NEW, BLANK_PAYMENT_INSTRUMENT_CHECKOUT_AUTO_PAY } from '../../../customer/makePayment/make.payment.constants';
import { createCardShortName, getCardName } from '../../../paymentBillingAddressForm/payment.billing.address.form.helper';
import { addUnsavedPaymentMethod, retrieveAvailablePaymentInstrumentTypes, saveAutoPayFlagStatus, selectPaymentMethod, setRecordPaymentInstrument, supplyPaymentInstrument, updatePaymentAccountsOnSelectedPaymentMethod } from '../../../../reducers/actions/customer.ewallet.actions';
import { SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../../../customer/ewallet/ewallet.constants';
import { setFormattedCityState } from '../../../../reducers/helpers/customer.helper';
import { DefaultPaymentAutoPayEnable, DefaultPaymentMethodSelector, DefaultPaymentMethodAutoPaySelector, IsRetrievingEwalletDataSelector, PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector, PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesAutoPayViewModelSelector, PaymentInstrumentTypeValueOptions, PaymentInstrumentTypeValueOptionsWithAutoPay, PaymentMethodWithConvergentBillerAccountsSelector, SelectedPaymentAutoPayEnable, SelectedPaymentForSubmitAtCheckoutSelector, SelectedPaymentMethodSelector, SupplyPaymentInstrumentSelector } from '../../../../reducers/selectors/customer.ewallet.selectors';
import { PostalCodeSelector, UpdateAddressPopupStateRegionProvinceValueOptions } from '../../../../reducers/selectors/customer.addresses.selectors';
import { setAddressData } from '../../../../reducers/actions/customer.addresses.actions';
import { BillCycleDetailsSelector, CandidateBillCyclesSelector, IsEvaluatingBillCyclesSelector, IsRetrievingBillCycleDetailsSelector, BillCycleDetailsLastRetrieveErrorSelector } from '../../../../reducers/selectors/customer.billcycle.selectors';
import { retrieveBillCycleDetails, retrieveCandidateBillCycles } from '../../../../reducers/actions/customer.billcycle.actions';
import { CurrentCustomerBillCycleSelector, CurrentCustomerCurrencyCodeSelector, CurrentCustomerIdSelector, CurrentCustomerSelector, CustomerIsFetchingDataSelector } from '../../../../reducers/selectors/customer.selectors';
import { CustomerInfoSelector, NewConnectCandidateBillCyclesSelector } from '../../../../reducers/selectors/new.connect.wizard.selectors';
// TODO - Customer Order wizard componentized steps should not be importing anything from a specific wizards
import { IsSubmittingCOSOrderSelector } from '../../../../reducers/selectors/transition.offer.wizard.selectors';
import { IsCalculatingQuoteSelector, IsMultiOfferSelector, OffCycleAlignmentSubscriberProductDataSelector, MultiOfferShoppingCartSelector, MultiOfferCartContainsOfferWithBillerRuleCycleLevelOtherThanItemSelector, AddOfferOffCycleAlignmentOptionsSelector, AddOfferSelectedOffCycleAlignmentsSelector, AddOfferProductIdsAndPricingPlanIdsOffCycleOfferSelector } from '../../../../reducers/selectors/add.offer.wizard.selectors';
import { SelectedContractSelector } from '../../../../reducers/selectors/contract.selectors';
import { retrieveOrderContext, retrieveOffCycleAlignmentOptions, retrieveTransferFromSubscriber, setChangesEffective, setCheckoutDetailsValidation, setDevicePaymentOptions, setExecutionOptions, setExternalContractId, setOrderDetails, setPurchaseOrderNumber, setOffCycleAlignmentSubscriberProductData, updateShippingDetails } from '../../../../reducers/actions/offering.order.actions';
import { SubscriberExternalGiftCardTypeOptionsWithRegexes } from '../../../../reducers/selectors/modify.payment.method.popup.selectors';
import { retrieveCustomer, updateSubscriberBillCycle } from '../../../../reducers/actions/customer.actions';
import { IsAutoPayEnabledSelector } from '../../../../reducers/selectors/autopay.configuration.selectors';
import { SelectedOfferingAssignedPaymentInstrumentSelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
import { OVERRIDE_BILLING_EFFECTIVE_DATE } from '../../../../security.attributes';
import { stateRequiredHelper } from '../../../customer/addresses/address.helper';
import { getInitialExecutionOptionsModel } from '../../../shared/presentationalComponents/orders/checkout/futureDatedOrders/future.dated.orders.helpers';
import { CUSTOMER_CATEGORY } from '../../../createCustomerPopup/create.customer.popup.constants';
export var CheckoutController = /*#__PURE__*/function () {
  function CheckoutController($filter, $ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, CheckoutController);
    Object.assign(this, {
      $filter: $filter,
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      addressFormModel: {},
      availableCredit: null,
      availableFinanceCredit: null,
      billCycleOptions: [],
      billCycleSelectOptionTemplate: require('invision-ui/lib/components/formControls/selectors/singleselect/optionTemplates/text.with.dot.delimited.subtext.html'),
      callRecalculateQuote: this.callRecalculateQuote.bind(this),
      cartHasOfferWithBillerRuleCycleLevelOtherThanItem: this.cartHasOfferWithBillerRuleCycleLevelOtherThanItem.bind(this),
      coreLocaleKeys: CoreLocaleKeys,
      customerCareKeys: CustomerCareKeys,
      customerCategory: CUSTOMER_CATEGORY,
      devicePaymentEditableItem: this.devicePaymentEditableItem.bind(this),
      doErrorsExistOnFdoForm: this.doErrorsExistOnFdoForm.bind(this),
      editedBillCycle: null,
      executionOptionsMinDate: moment(this.getTomorrow()).startOf('day').utc().toISOString(),
      executionOptionsModel: {},
      extraErrorMessages: [],
      getFormatedCityStateForShippingAddress: this.getFormatedCityStateForShippingAddress.bind(this),
      handleIsAutoPayActiveChanged: this.handleIsAutoPayActiveChanged.bind(this),
      handleItemDownPaymentChanged: this.handleItemDownPaymentChanged.bind(this),
      handlePaymentTypeChange: this.handlePaymentTypeChange.bind(this),
      INVOICE_TIMING_CONSTANTS: INVOICE_TIMING_CONSTANTS,
      isAlignRenewals: false,
      isAutoPayActive: false,
      isAutoPayEdit: false,
      isShipping: this.isShipping.bind(this),
      itemDownPayment: null,
      MAXIMUM_COMMENT_LENGTH: 500,
      onBillCycleSelectOptionSelected: this.onBillCycleSelectOptionSelected.bind(this),
      onExecutionOptionChange: this.onExecutionOptionChange.bind(this),
      onFdoFormValidityChange: this.onFdoFormValidityChange.bind(this),
      onListUpdated: this.onListUpdated.bind(this),
      onOfferAdditionalPropertyChanged: this.onOfferAdditionalPropertyChanged.bind(this),
      onOfferAdditionalPropertyListUpdated: this.onOfferAdditionalPropertyListUpdated.bind(this),
      onPropertyChanged: this.onPropertyChanged.bind(this),
      onSubmitEditModal: this.onSubmitEditModal.bind(this),
      orderDetails: {},
      paymentInstrument: {},
      reasonCodes: [],
      showSideNavEditModal: this.showSideNavEditModal.bind(this),
      showOrderDetails: this.showOrderDetails.bind(this),
      SCHEDULED_ORDER_OPTIONS: SCHEDULED_ORDER_OPTIONS,
      SIDE_NAV_FORMS: {
        BILLING_AND_SCHEDULING: 'editModalBillingAndSchedulingForm',
        DEVICE_PAYMENT: 'editModalDevicePaymentForm',
        SHIPPING: 'editModalShippingForm'
      },
      selectPaymentInstrument: this.selectPaymentInstrument.bind(this),
      selectPaymentInstrumentOnRecord: this.selectPaymentInstrumentOnRecord.bind(this),
      setOrderDetails: this.setOrderDetails.bind(this),
      uiNotificationService: uiNotificationService,
      CONSTANTS: {
        TRUE_VALUE: true,
        FALSE_VALUE: false
      },
      edit: {
        financedItems: []
      },
      onAddressFormUpdate: this.onAddressFormUpdate.bind(this),
      handleCreditBreachValidations: this.handleCreditBreachValidations.bind(this),
      updateSubscriberProductIds: this.updateSubscriberProductIds.bind(this),
      updateSelectedDeliveryMethod: this.updateSelectedDeliveryMethod.bind(this),
      updateSelectedShippingAddress: this.updateSelectedShippingAddress.bind(this)
    });
  }
  return _createClass(CheckoutController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.PaymentInstrumentType, CODES.PaymentInstrumentConfiguration, CODES.FutureDatedOrderConfiguration, CODES.ExternalGiftCardType, CODES.ExternalBillType, CODES.SubscriberSearchConfig, CODES.ReasonCodes];
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          addressCountries: MetadataOptionsForCodeValuesSelector(CODES.AddressCountry, store),
          addressCountriesLoaded: MetadataCodeLoadedSelector(CODES.AddressCountry, store),
          addressRequirements: MetadataCodeTypeSelector(CODES.AddressRequirements, store),
          addressRequirementsLoaded: MetadataCodeLoadedSelector(CODES.AddressRequirements, store),
          addressStatesOptions: UpdateAddressPopupStateRegionProvinceValueOptions(store),
          addressStateTypesLoaded: MetadataCodeLoadedSelector(CODES.AddressStateProvinceRegion, store),
          billCycleDetails: BillCycleDetailsSelector(store),
          billCycleDetailsLastRetrieveError: BillCycleDetailsLastRetrieveErrorSelector(store),
          billingEffectiveDateOptions: BillingEffectiveDateOptionsSelector(store),
          billingEffectiveDateSettings: BillingEffectiveDateSettingsSelector(store),
          candidateBillCycles: CandidateBillCyclesSelector(store),
          candidateBillCyclesNewConnect: NewConnectCandidateBillCyclesSelector(store),
          cartContainsOfferWithBillerRuleCycleLevelOtherThanItem: CartContainsOfferWithBillerRuleCycleLevelOtherThanItemSelector(store),
          changesEffective: SelectedOfferChangesEffectiveSelector(store),
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          creditCardTypes: MetadataCodeTypeSelector(CODES.CreditCardType, store),
          currentBusinessUnitCurrencyCode: CurrentBusinessUnitCurrencyCodeSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerBillCycle: CurrentCustomerBillCycleSelector(store),
          currentCustomerCurrencyCode: CurrentCustomerCurrencyCodeSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          customerInfoNewConnect: CustomerInfoSelector(store),
          defaultPaymentAutoPayEnable: DefaultPaymentAutoPayEnable(store),
          defaultPaymentMethod: DefaultPaymentMethodSelector(store),
          defaultPaymentMethodWithAutoPay: DefaultPaymentMethodAutoPaySelector(store),
          editModalSideNavList: OfferingOrderCheckoutPageEditFormSelector(store),
          executionOptions: SelectedOrderExecutionOptionsSelector(store),
          externalBillTypes: MetadataCodeTypeSelector(CODES.ExternalBillType, store),
          externalContractId: SelectedOfferExternalContractIdSelector(store),
          externalGiftCardTypes: SubscriberExternalGiftCardTypeOptionsWithRegexes(store),
          fdoAllowedInBunt: IsFutureDatedOrderAllowedInBunt(store),
          fdoConfiguration: MetadataCodeTypeSelector(CODES.FutureDatedOrderConfiguration, store),
          fdoMaxDate: GetMaxDateForFutureDatedOrder(store),
          isAutoPayEnabled: IsAutoPayEnabledSelector(store),
          isCalculatingQuote: IsCalculatingQuoteSelector(store),
          isDbss: IsDbss(store),
          isEvaluatingBillCycles: IsEvaluatingBillCyclesSelector(store),
          isFetchingCustomerData: CustomerIsFetchingDataSelector(store),
          isFetchingEwalletData: IsRetrievingEwalletDataSelector(store),
          isMultioffer: IsMultiOfferSelector(store),
          isQuotingOffer: IsQuotingOfferSelector(store),
          isRetrievingBillCycleDetails: IsRetrievingBillCycleDetailsSelector(store),
          isSubmittingCOSOrder: IsSubmittingCOSOrderSelector(store),
          isSubmittingOrder: IsSubmittingOrderSelector(store),
          multiOfferCartContainsOfferWithBillerRuleCycleLevelOtherThanItem: MultiOfferCartContainsOfferWithBillerRuleCycleLevelOtherThanItemSelector(store),
          multiOfferShoppingCart: MultiOfferShoppingCartSelector(store),
          offCycleAlignments: OfferingOrderOffCycleAlignmentSelector(store),
          offCycleAlignmentOptions: AddOfferOffCycleAlignmentOptionsSelector(store),
          offCycleAlignmentSubscriberProductData: OffCycleAlignmentSubscriberProductDataSelector(store),
          paymentInstruments: PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector(store),
          paymentInstrumentsAutoPay: PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesAutoPayViewModelSelector(store),
          paymentInstrumentsWithAutoPay: PaymentInstrumentTypeValueOptionsWithAutoPay(store),
          paymentInstrumentTypeValueOptions: PaymentInstrumentTypeValueOptions(store),
          paymentMethodWithConvergentAccount: PaymentMethodWithConvergentBillerAccountsSelector(store),
          postalCode: PostalCodeSelector(store),
          purchaseOrderNumber: SelectedOfferPurchaseOrderNumberSelector(store),
          productIdsAndPricingPlanIdsOffCycleOffers: AddOfferProductIdsAndPricingPlanIdsOffCycleOfferSelector(store),
          reasonCodes: MetadataCodeTypeDictionarySelector(CODES.ReasonCodes, store),
          reasonCodesLoaded: MetadataCodeLoadedSelector(CODES.ReasonCodes, store),
          selectedContract: SelectedContractSelector(store),
          selectedOffCycleAlignments: AddOfferSelectedOffCycleAlignmentsSelector(store),
          selectedOfferingAssignedPaymentInstrument: SelectedOfferingAssignedPaymentInstrumentSelector(store),
          selectedPaymentClean: SelectedPaymentForSubmitAtCheckoutSelector(store),
          selectedPaymentMethod: SelectedPaymentMethodSelector(store),
          selectedPaymentMethodAutoPay: SelectedPaymentAutoPayEnable(store),
          selectedShippingAddressAndMethod: SelectedShippingAddressAndMethodSelector(store),
          shoppingCart: ShoppingCartSelector(store),
          subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
          subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store),
          supplyPaymentInstrument: SupplyPaymentInstrumentSelector(store),
          updatedShippingAddress: UpdatedShippingAddressSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        addUnsavedPaymentMethod: addUnsavedPaymentMethod,
        fetchAddressCountryTypes: fetchAddressCountryTypes,
        fetchAddressStateTypes: fetchAddressStateTypes,
        fetchCodeTypes: fetchCodeTypes,
        fetchCreditCardTypes: fetchCreditCardTypes,
        retrieveAvailablePaymentInstrumentTypes: retrieveAvailablePaymentInstrumentTypes,
        retrieveBillCycleDetails: retrieveBillCycleDetails,
        retrieveCandidateBillCycles: retrieveCandidateBillCycles,
        retrieveCustomer: retrieveCustomer,
        retrieveOffCycleAlignmentOptions: retrieveOffCycleAlignmentOptions,
        retrieveOrderContext: retrieveOrderContext,
        retrieveTransferFromSubscriber: retrieveTransferFromSubscriber,
        saveAutoPayFlagStatus: saveAutoPayFlagStatus,
        selectPaymentMethod: selectPaymentMethod,
        setAddressData: setAddressData,
        setChangesEffective: setChangesEffective,
        setCheckoutDetailsValidation: setCheckoutDetailsValidation,
        setDevicePaymentOptions: setDevicePaymentOptions,
        setExecutionOptions: setExecutionOptions,
        setExternalContractId: setExternalContractId,
        setOrderDetails: setOrderDetails,
        setPurchaseOrderNumber: setPurchaseOrderNumber,
        setRecordPaymentInstrument: setRecordPaymentInstrument,
        setOffCycleAlignmentSubscriberProductData: setOffCycleAlignmentSubscriberProductData,
        supplyPaymentInstrument: supplyPaymentInstrument,
        updatePaymentAccountsOnSelectedPaymentMethod: updatePaymentAccountsOnSelectedPaymentMethod,
        updateShippingDetails: updateShippingDetails,
        updateSubscriberBillCycle: updateSubscriberBillCycle
      };
      var initialExecutionOptionsModelRelatedPromises = [];
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.onCheckoutStepSubmit({
        handleCheckoutStepSubmit: this.handleCreditBreachValidations
      });
      this.PaymentTypes = SUPPORTED_PAYMENT_INSTRUMENT_TYPES;
      if (this.serviceAddress) {
        var cityState = {
          city: this.serviceAddress.City,
          stateRegionProvince: this.serviceAddress.State
        };
        this.formattedCityState = setFormattedCityState(cityState);
      }
      this.isAutoPayEdit = this.state.defaultPaymentAutoPayEnable || this.state.selectedPaymentMethodAutoPay ? clone(this.state.defaultPaymentAutoPayEnable || this.state.selectedPaymentMethodAutoPay) : false;
      if (this.isBillingEffectiveDateShown()) {
        initialExecutionOptionsModelRelatedPromises.push(this.actions.retrieveOrderContext(this.transferFromSubscriberId, this.isNewConnect ? null : this.state.currentCustomerId).catch(function (error) {
          _this.uiNotificationService.transientError(error.translatedMessage);
        }));
      }
      this.getShoppingCartItemsForRetrievePaymentInstrumentTypes = function () {
        if (_this.state.multiOfferShoppingCart && _this.state.multiOfferShoppingCart.Items) {
          var _this$state$multiOffe, _this$state$multiOffe2;
          return (_this$state$multiOffe = _this.state.multiOfferShoppingCart.AddItems) !== null && _this$state$multiOffe !== void 0 && _this$state$multiOffe.length || (_this$state$multiOffe2 = _this.state.multiOfferShoppingCart.ModifyItems) !== null && _this$state$multiOffe2 !== void 0 && _this$state$multiOffe2.length ? [].concat(_toConsumableArray(_this.state.multiOfferShoppingCart.AddItems), _toConsumableArray(_this.state.multiOfferShoppingCart.ModifyItems)) : _this.state.multiOfferShoppingCart.Items;
        } else if (_this.state.shoppingCart && _this.state.shoppingCart.Items) {
          var _this$state$shoppingC, _this$state$shoppingC2;
          return (_this$state$shoppingC = _this.state.shoppingCart.AddItems) !== null && _this$state$shoppingC !== void 0 && _this$state$shoppingC.length || (_this$state$shoppingC2 = _this.state.shoppingCart.ModifyItems) !== null && _this$state$shoppingC2 !== void 0 && _this$state$shoppingC2.length ? [].concat(_toConsumableArray(_this.state.shoppingCart.AddItems), _toConsumableArray(_this.state.shoppingCart.ModifyItems)) : _this.state.shoppingCart.Items;
        }
        return [];
      };
      this.actions.retrieveAvailablePaymentInstrumentTypes({
        Currency: this.state.currentCustomerCurrencyCode || this.state.currentBusinessUnitCurrencyCode,
        ShoppingCart: {
          Items: this.getShoppingCartItemsForRetrievePaymentInstrumentTypes()
        }
      }).then(function () {
        if (!_this.paymentInfo && !_this.isAutoPayActive) {
          _this.supplyPaymentInstrument = false;
          _this.serviceAddressAsBillingAddress = true;
          _this.paymentInstrument = Object.assign(cloneDeep(BLANK_PAYMENT_INSTRUMENT_CHECKOUT_AUTO_PAY), {
            Type: _this.state.paymentInstrumentTypeValueOptions.length ? _this.state.paymentInstrumentTypeValueOptions[0].paymentInstrumentType.Value : BLANK_PAYMENT_INSTRUMENT_CHECKOUT_AUTO_PAY.Type
          });
          _this.billingAddress = cloneDeep(BLANK_BILLING_ADDRESS_NEW);
        } else {
          _this.supplyPaymentInstrument = true;
          _this.serviceAddressAsBillingAddress = _this.paymentInfo.BillingAddressIsServiceAddress;
          _this.paymentInstrument = {
            CreditCard: Object.assign({}, _this.paymentInfo.CreditCard),
            ConvergentBillerPaymentInstrumentAccounts: Object.assign({}, _this.paymentInfo.ConvergentBillerPaymentInstrumentAccounts),
            ECheck: Object.assign({}, _this.paymentInfo.ECheck),
            Type: _this.paymentInfo.Type
          };
        }
      }).catch(function (error) {
        _this.uiNotificationService.transientError(error.translatedMessage);
      });
      if (this.paymentInfo) {
        this.billingAddress = Object.assign({}, this.paymentInfo.BillingAddress);
        this.addressFormModel.addressLine1 = this.billingAddress.LineOne;
        this.addressFormModel.addressLine2 = this.billingAddress.LineTwo;
        this.addressFormModel.city = this.billingAddress.City;
        this.addressFormModel.country = this.billingAddress.Country;
        this.addressFormModel.stateRegionProvince = this.billingAddress.State;
        this.addressFormModel.postalCode = this.billingAddress.PostalCode;
        this.setCountryData();
      }
      this.newPaymentInstrument = this.state.paymentInstruments.length === 0;
      if (!this.newPaymentInstrument) {
        if (this.state.selectedPaymentMethod && this.state.supplyPaymentInstrument) {
          this.supplyPaymentInstrument = true;
        } else {
          var defaultSelectedPaymentInstrument = this.state.selectedOfferingAssignedPaymentInstrument || this.state.defaultPaymentMethodWithAutoPay;
          this.selectPaymentInstrument(defaultSelectedPaymentInstrument, true);
        }
      }
      if (this.state.creditCardTypes.length === 0) {
        this.actions.fetchCreditCardTypes();
      }
      if (!this.state.addressCountriesLoaded) {
        this.actions.fetchAddressCountryTypes();
      }
      if (!this.state.addressStateTypesLoaded) {
        this.actions.fetchAddressStateTypes();
      }
      codeTables.forEach(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          _this.actions.fetchCodeTypes(codeType).then(function () {
            if (codeType === CODES.SubscriberSearchConfig) {
              _this.initializeIsAutopayActive();
            }
          }).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          });
        } else {
          _this.initializeIsAutopayActive();
        }
      });
      if (this.state.isDbss) {
        Promise.resolve().then(function () {
          if (_this.state.currentCustomerId) {
            return _this.actions.retrieveCustomer(_this.state.currentCustomerId).then(function () {
              return _this.setInitialBillCycleSelection();
            });
          } else if (_this.state.candidateBillCycles.length > 0) {
            _this.setDefaultBillCycle(true);
          }
        }).then(function () {
          _this.billCycleOptions = _this.getBillCycleOptions();
        });
      }
      this.purchaseOrderNumber = this.state.purchaseOrderNumber ? clone(this.state.purchaseOrderNumber) : null;
      this.externalContractId = this.state.externalContractId ? clone(this.state.externalContractId) : null;
      this.additionalPropertyFields = clone(this.additionalPropertiesCollection);
      this.offerAdditionalPropertyFields = clone(this.offerAdditionalPropertiesCollection);
      var EMPTY_RENEWAL_DATE_OBJ = {};
      if (this.isEditFlow()) {
        if (this.state.purchaseOrderNumber) {
          this.purchaseOrderNumberReadOnly = true;
        }
        if (this.state.externalContractId) {
          this.externalContractIdReadOnly = true;
        }
      }
      this.reasonCodes = this.getFilteredReasonCodes();
      this.contractTermsConditionsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.contractTermsConditionsPopupApi = api;
        }
      };
      this.openContractTermsConditionsPopup = function () {
        _this.contractTermsConditionsPopupOpened = true;
        _this.$timeout(function () {
          _this.contractTermsConditionsPopupApi.open();
        });
      };
      this.handleCloseContractTermsConditionsPopup = function () {
        _this.contractTermsConditionsPopupApi.close();
        _this.contractTermsConditionsPopupOpened = false;
      };
      this.downPaymentsSchedulingAndBillingPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.devicePaymentsSchedulingAndBillingPopupApi = api;
        }
      };
      this.editCheckoutPageInformationPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var api = _ref3.api;
          _this.editCheckoutPageInformationPopupApi = api;
        }
      };
      this.changeShippingAddressPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref4) {
          var api = _ref4.api;
          _this.changeShippingAddressPopupApi = api;
        }
      };
      this.openChangeShippingAddressPopup = function () {
        _this.changeShippingAddressPopupOpened = true;
        _this.$timeout(function () {
          _this.changeShippingAddressPopupApi.open();
        });
      };
      this.closeChangeShippingAddressPopup = function () {
        _this.changeShippingAddressPopupApi.close();
        _this.changeShippingAddressPopupOpened = false;
      };
      this.openEditCheckoutPageInformationPopup = function (editFormName) {
        var _this$state$selectedO;
        _this.isAlignRenewals = !!((_this$state$selectedO = _this.state.selectedOffCycleAlignments) !== null && _this$state$selectedO !== void 0 && _this$state$selectedO.length);
        _this.renewalData = clone(_this.state.offCycleAlignmentSubscriberProductData);
        _this.showErrorSummary = false;
        _this.selectedItemFormName = editFormName;
        _this.actions.setCheckoutDetailsValidation({
          formName: editFormName,
          isActive: true
        });
        _this.edit.financedItems = clone(_this.financedItems);
        _this.billCycleOptions = _this.getBillCycleOptions();
        _this.editedBillCycle = _this.selectedBillCycle;
        _this.editCheckoutPageInformationPopupOpened = true;
        _this.$timeout(function () {
          _this.editCheckoutPageInformationPopupApi.open();
        });
      };
      this.closeEditCheckoutPageInformationPopup = function () {
        _this.editCheckoutPageInformationPopupApi.close();
        _this.editCheckoutPageInformationPopupOpened = false;
      };
      this.closeDownPaymentsSchedulingAndBillingPopup = function () {
        _this.executionOptionsModel = {};
        _this.devicePaymentsSchedulingAndBillingPopupApi.close();
      };
      if (!this.state.addressRequirementsLoaded) {
        this.actions.fetchCodeTypes(CODES.AddressRequirements);
      }
      if (!this.state.reasonCodesLoaded) {
        this.actions.fetchCodeTypes(CODES.ReasonCodes);
      }
      this.isStateRegionProvinceRequired = stateRequiredHelper(this.state.addressRequirements, this.state.addressStatesOptions);
      this.changesEffectiveSelection = this.state.changesEffective ? "".concat(this.state.changesEffective) : "".concat(INVOICE_TIMING_CONSTANTS.INVOICE_IMMEDIATELY);
      this.handleCreditBreachValidations();
      Promise.all(initialExecutionOptionsModelRelatedPromises).then(function () {
        var getInitialExecutionOptionsModelArgs = {
          executionOptionsSavedCopy: _this.state.executionOptions,
          showImmediateOption: !_this.transferFromSubscriberId,
          showBillCycleOption: _this.hasInvoiceItems && !_this.transferFromSubscriberId && _this.cartHasOfferWithBillerRuleCycleLevelOtherThanItem(),
          showDatePickerOption: !_this.transferFromSubscriberId,
          isBillingEffectiveDateShown: _this.isBillingEffectiveDateShown(),
          billingEffectiveDateOptions: _this.state.billingEffectiveDateOptions
        };
        _this.executionOptionsModel = getInitialExecutionOptionsModel(getInitialExecutionOptionsModelArgs);
        _this.actions.setExecutionOptions(_this.executionOptionsModel);
        _this.executionOptionsModel = {};
      });
      if (this.showAlignRenewals && this.state.productIdsAndPricingPlanIdsOffCycleOffers.length) {
        this.actions.retrieveOffCycleAlignmentOptions(this.state.productIdsAndPricingPlanIdsOffCycleOffers, this.state.currentCustomerId);
      }
      if (!this.state.isMultioffer) {
        this.state.offCycleAlignmentOptions.forEach(function (offer) {
          EMPTY_RENEWAL_DATE_OBJ[offer.offeringInstanceId] = {};
          offer.pricingPlans.map(function (pricingPlan) {
            EMPTY_RENEWAL_DATE_OBJ[offer.offeringInstanceId][pricingPlan.id] = {
              'pricingPlanId': null,
              'productId': null,
              'nextRenewalDate': null,
              'subscriberProductId': null
            };
          });
        });
        this.renewalData = clone(EMPTY_RENEWAL_DATE_OBJ);
        this.actions.setOffCycleAlignmentSubscriberProductData(this.renewalData);
      }
      this.shipToName = this.state.updatedShippingAddress ? this.state.updatedShippingAddress.ShipToName : this.formattedName;
      this.state.selectedShippingAddressAndMethod && this.state.selectedShippingAddressAndMethod.methodId && this.updateSelectedDeliveryMethod(this.state.selectedShippingAddressAndMethod.methodId);
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (this.state && (pathOr(false, ['availableCredit', 'currentValue'], changesObj) || pathOr(false, ['availableFinanceCredit', 'currentValue'], changesObj))) {
        this.handleCreditBreachValidations();
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.setExecutionOptions({});
      this.disconnectRedux();
    }
  }, {
    key: "isShipping",
    value: function isShipping() {
      return this.shippingAddress;
    }
  }, {
    key: "showSideNavEditModal",
    value: function showSideNavEditModal() {
      return this.state.editModalSideNavList.length && this.canShowFdoAndBed() && !this.devicePaymentEditableItem();
    }
  }, {
    key: "devicePaymentEditableItem",
    value: function devicePaymentEditableItem() {
      return this.financedItems.length === 1 && this.financedItems.find(function (item) {
        return item.downPaymentType === DOWN_PAYMENT_TYPE.DOWN_PAYMENT_EQUAL_TO_FIRST_INSTALLMENT ? false : !!item.downPaymentType && item.isFullUpfrontPayment;
      });
    }
  }, {
    key: "getFormatedCityStateForShippingAddress",
    value: function getFormatedCityStateForShippingAddress() {
      if (this.state.updatedShippingAddress) {
        var cityState = {
          city: this.state.updatedShippingAddress.City,
          stateRegionProvince: this.state.updatedShippingAddress.State
        };
        return setFormattedCityState(cityState);
      }
    }
  }, {
    key: "initializeIsAutopayActive",
    value: function initializeIsAutopayActive() {
      this.isAutoPayActive = this.paymentInfo && this.paymentInfo.ConvergentBillerPaymentInstrumentAccounts && this.paymentInfo.ConvergentBillerPaymentInstrumentAccounts.length && this.isOrderPostPaid && this.state.isAutoPayEnabled && this.state.isDbss ? this.paymentInfo.ConvergentBillerPaymentInstrumentAccounts[0].AutoPay : false;
    }
  }, {
    key: "getPaymentInstrumentObject",
    value: function getPaymentInstrumentObject(paymentInfoObj) {
      if (paymentInfoObj.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD || !pathOr(0, ['Type', 'length'], paymentInfoObj)) {
        return paymentInfoObj.CreditCard;
      } else if (paymentInfoObj.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.E_CHECK) {
        return paymentInfoObj.ECheck;
      } else if (paymentInfoObj.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD) {
        return paymentInfoObj.ExternalGiftCard;
      } else if (paymentInfoObj.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.INTERNAL_GIFT_CARD) {
        return paymentInfoObj.GiftCard;
      } else if (paymentInfoObj.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_BILL) {
        return paymentInfoObj.ExternalBill;
      }
    }
  }, {
    key: "getTomorrow",
    value: function getTomorrow() {
      var today = moment();
      return moment(today).add(1, 'days');
    }
  }, {
    key: "buildPaymentInstrumentObject",
    value: function buildPaymentInstrumentObject() {
      var defaultAutopayObject = [{
        AutoPay: this.isAutoPayActive
      }];
      if (!this.isPaymentInstrumentRequired && !this.hasDownPaymentItemsChanges() && !this.supplyPaymentInstrument && !(this.isOrderPostPaid && this.isAutoPayActive && this.state.isAutoPayEnabled && this.state.isDbss)) {
        // don't fill the redux store with unneeded cc data and don't pass to api
        return null;
      }
      if (!this.serviceAddressAsBillingAddress) {
        this.billingAddress.Name = this.billingAddress.LineOne; // Name is required by the API and needs to be unique.
      }
      if (this.newPaymentInstrument) {
        delete this.paymentInstrument.Id;
      }
      var paymentInstrumentTypes = this.isAutoPayActive ? this.state.paymentInstrumentsWithAutoPay : this.state.paymentInstrumentTypeValueOptions;
      var paymentInstrumentObject = this.getPaymentInstrumentObject(this.paymentInstrument);
      return Object.assign(reject(isEmpty, this.paymentInstrument), {
        BillingAddressIsServiceAddress: this.serviceAddressAsBillingAddress,
        BillingAddress: !this.serviceAddressAsBillingAddress ? this.billingAddress : this.serviceAddress,
        ConvergentBillerPaymentInstrumentAccounts: this.isOrderPostPaid ? defaultAutopayObject : undefined,
        Name: createCardShortName(paymentInstrumentObject, getCardName(paymentInstrumentObject.Type, this.paymentInstrument, this.state.creditCardTypes, undefined, paymentInstrumentTypes))
      });
    }
  }, {
    key: "hasDownPaymentItemsChanges",
    value: function hasDownPaymentItemsChanges() {
      return this.financedItems && this.financedItems.length && this.financedItems.filter(function (item) {
        return item.downPayment || item.isFullPriceDownPaymentSelected || item.isDownPaymentEqualToFirstInstallmentSelected;
      }).length;
    }
  }, {
    key: "shouldShowFdoExecutionOptionsError",
    value: function shouldShowFdoExecutionOptionsError() {
      return this.wizardForm.$submitted && this.errorsExistOnForm;
    }
  }, {
    key: "shouldShowCreditLimitBreached",
    value: function shouldShowCreditLimitBreached() {
      this.breachedCreditLimit = this.isCreditLimitBreached ? i18n.translate(CustomerCareKeys.CREDIT_LIMIT_BREACHED, {
        breachAmount: this.$filter('invCurrency')(this.availableCredit, this.state.currentCustomer.SubscriberCurrency)
      }) : null;
      return this.isCreditLimitBreached && this.availableCredit < 0;
    }
  }, {
    key: "shouldShowFinanceLimitBreached",
    value: function shouldShowFinanceLimitBreached() {
      this.breachedFinanceLimit = this.availableFinanceCredit > 0 ? i18n.translate(CustomerCareKeys.FINANCE_LIMIT_BREACHED, {
        breachAmount: this.$filter('invCurrency')(this.availableFinanceCredit, this.state.currentCustomer.SubscriberCurrency)
      }) : null;
      return this.availableFinanceCredit && !(this.availableFinanceCredit < 0);
    }
  }, {
    key: "shouldShowCreditAndFinanceLimitBreaches",
    value: function shouldShowCreditAndFinanceLimitBreaches() {
      return this.shouldShowCreditLimitBreached() || this.shouldShowFinanceLimitBreached();
    }
  }, {
    key: "fetchQuote",
    value: function fetchQuote(newConnect) {
      // TODO: CustomerOrder: The checkout component should have no concept of which it's calling.
      // This breaks the wizard design and should be handled by the parent consuming component through a binding.
      this.actions.setOffCycleAlignmentSubscriberProductData(this.renewalData);
      return newConnect ? this.fetchQuoteNewConnect()(this.state.customerInfoNewConnect, this.state.shoppingCart, (this.selectedBillCycle || {}).name) : this.fetchOrderQuote()(this.state.currentCustomer, this.state.isMultioffer ? this.state.multiOfferShoppingCart : this.state.shoppingCart, (this.selectedBillCycle || {}).name, this.state.isDbss);
    }
  }, {
    key: "isFirstOrder",
    value: function isFirstOrder() {
      return !this.state.currentCustomerBillCycle;
    }
  }, {
    key: "setOrderDetails",
    value: function setOrderDetails() {
      this.actions.setOrderDetails(this.orderDetails);
    }

    //TODO ASC-103364. this is temporary fix to get errors from address component. Reference story should add error handling in the component and remove this workaround.
  }, {
    key: "getControlFromAddressComponent",
    value: function getControlFromAddressComponent(controlName) {
      return this.paymentInstrumentForm['addressWrapupController.singleAddressFormFormApi'] && this.paymentInstrumentForm['addressWrapupController.singleAddressFormFormApi']['$ctrl.formApi'] ? this.paymentInstrumentForm['addressWrapupController.singleAddressFormFormApi']['$ctrl.formApi'].$$controls.find(function (control) {
        return control.$name.includes(controlName);
      }) : undefined;
    }
  }, {
    key: "setInitialBillCycleSelection",
    value: function setInitialBillCycleSelection() {
      var _this2 = this;
      if (this.cartHasOfferWithBillerRuleCycleLevelOtherThanItem()) {
        if (this.isFirstOrder() && !this.transferFromSubscriberId) {
          return this.actions.retrieveCandidateBillCycles(this.state.currentCustomerId, this.isOrderPostPaid ? subscriberOrderTypeEnum.postpaid.value : subscriberOrderTypeEnum.prepaid.value).then(function () {
            if (_this2.state.candidateBillCycles.length > 0) {
              _this2.setDefaultBillCycle(false);
            }
          });
        } else if (this.isFirstOrder() && this.transferFromSubscriberId) {
          // If transferring, and the To Subscriber does not have a bill cycle, it inherits the From's, otherwise it keeps it's current.
          return this.actions.retrieveTransferFromSubscriber(this.transferFromSubscriberId).then(function (response) {
            return _this2.actions.retrieveBillCycleDetails(response.Subscriber.SubscriberTypeDetails.BillCycle).then(function (detailsResponse) {
              _this2.selectedBillCycle = {
                billDate: _this2.$filter('localShortDate')(detailsResponse.BillCycleDetails.BillDate),
                id: detailsResponse.BillCycleDetails.Id,
                name: detailsResponse.BillCycleDetails.Name,
                paymentDueDate: _this2.$filter('localShortDate')(detailsResponse.BillCycleDetails.PaymentDueDate),
                repeatInterval: detailsResponse.BillCycleDetails.RepeatInterval,
                repeatType: detailsResponse.BillCycleDetails.RepeatType
              };
              _this2.initialBillcycleId = _this2.selectedBillCycle.id;
              _this2._updateBillCycle(_this2.selectedBillCycle.name);
            });
          }).catch(function (error) {
            _this2.uiNotificationService.transientError(error.translatedMessage);
          });
        } else {
          return this.actions.retrieveBillCycleDetails(this.state.currentCustomerBillCycle).catch(function () {
            _this2.uiNotificationService.error(i18n.translate(CustomerCareKeys.CHECKOUT.RETRIEVE_BILL_CYCLE_DETAILS_ERROR, {
              id: _this2.state.currentCustomerBillCycle
            }), _this2.state.billCycleDetailsLastRetrieveError.translatedMessage);
            _this2.actions.retrieveCandidateBillCycles(_this2.state.currentCustomerId, _this2.isOrderPostPaid ? subscriberOrderTypeEnum.postpaid.value : subscriberOrderTypeEnum.prepaid.value);
          }).then(function () {
            _this2.selectedBillCycle = _this2.state.billCycleDetails;
            _this2.initialBillcycleId = _this2.selectedBillCycle.id;
            _this2._updateBillCycle(_this2.selectedBillCycle.name);
          });
        }
      } else {
        return Promise.resolve();
      }
    }
  }, {
    key: "cartHasOfferWithBillerRuleCycleLevelOtherThanItem",
    value: function cartHasOfferWithBillerRuleCycleLevelOtherThanItem() {
      return this.orderScenario === ORDER_SCENARIOS.ADD_OFFER && this.state.multiOfferCartContainsOfferWithBillerRuleCycleLevelOtherThanItem || this.orderScenario !== ORDER_SCENARIOS.ADD_OFFER && this.state.cartContainsOfferWithBillerRuleCycleLevelOtherThanItem;
    }
  }, {
    key: "setDefaultBillCycle",
    value: function setDefaultBillCycle(newConnect) {
      this.selectedBillCycle = newConnect ? this.state.candidateBillCyclesNewConnect[0] : this.state.candidateBillCycles[0];
      this.initialBillcycleId = this.selectedBillCycle.id;
      this._updateBillCycle(this.selectedBillCycle.name);
    }
  }, {
    key: "getCandidateBillCycles",
    value: function getCandidateBillCycles() {
      return this.state.currentCustomerId ? this.state.candidateBillCycles : this.state.candidateBillCyclesNewConnect;
    }
  }, {
    key: "buildWalletRequest",
    value: function buildWalletRequest() {
      return {
        customerId: this.customer.Id
      };
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.isCreatingOrUpdatingCustomer || this.isFetchingData || this.state.isCalculatingQuote || this.state.isEvaluatingBillCycles || this.state.isFetchingCustomerData || this.state.isFetchingEwalletData || this.state.isQuotingOffer || this.state.isRetrievingBillCycleDetails || this.state.isSubmittingCOSOrder;
    }
  }, {
    key: "selectPaymentInstrument",
    value: function selectPaymentInstrument(paymentInstrument) {
      var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.actions.saveAutoPayFlagStatus(this.isAutoPayEdit);
      this.actions.selectPaymentMethod(paymentInstrument);
      if (this.isOrderPostPaid) {
        this.actions.updatePaymentAccountsOnSelectedPaymentMethod({
          ConvergentBillerPaymentInstrumentAccounts: this.state.paymentMethodWithConvergentAccount.ConvergentBillerPaymentInstrumentAccounts
        });
      }
      this.actions.supplyPaymentInstrument(true);
      if (!(this.state.isDbss || isInit)) {
        // Quote does not need to be recalled after init in DBSS, since it is based on Service Address,
        // OTT does need this as it is based on Billing Address.
        this.callRecalculateQuote(paymentInstrument);
      }
    }
  }, {
    key: "selectPaymentInstrumentOnRecord",
    value: function selectPaymentInstrumentOnRecord(paymentInstrument) {
      this.actions.saveAutoPayFlagStatus(this.isAutoPayEdit);
      if (!pathOr(true, ['recordPayment'], paymentInstrument)) {
        this.actions.saveAutoPayFlagStatus(this.isAutoPayEdit = false);
        this.actions.addUnsavedPaymentMethod(paymentInstrument);
      }
      this.actions.selectPaymentMethod(paymentInstrument);
      if (this.isOrderPostPaid) {
        this.actions.updatePaymentAccountsOnSelectedPaymentMethod({
          ConvergentBillerPaymentInstrumentAccounts: this.state.paymentMethodWithConvergentAccount.ConvergentBillerPaymentInstrumentAccounts
        });
      }
      this.actions.supplyPaymentInstrument(true);
      if (!this.state.isDbss) {
        this.callRecalculateQuote(paymentInstrument.recordPayment ? paymentInstrument : this.state.selectedPaymentClean);
      }
    }
  }, {
    key: "disableAutoPayCheck",
    value: function disableAutoPayCheck() {
      return this.state.selectedPaymentMethod && pathOr(true, ['recordPayment'], this.state.selectedPaymentMethod);
    }
  }, {
    key: "updateSelectPaymentInstrument",
    value: function updateSelectPaymentInstrument() {
      this.actions.saveAutoPayFlagStatus(this.isAutoPayEdit);
      this.actions.selectPaymentMethod(this.state.paymentMethodWithConvergentAccount);
      if (this.isOrderPostPaid) {
        this.actions.updatePaymentAccountsOnSelectedPaymentMethod({
          ConvergentBillerPaymentInstrumentAccounts: this.state.paymentMethodWithConvergentAccount.ConvergentBillerPaymentInstrumentAccounts
        });
      }
    }
  }, {
    key: "addressText",
    value: function addressText() {
      return i18n.translate(this.serviceAddress ? this.customerCareKeys.ADDRESSES.SERVICE_ADDRESS : this.customerCareKeys.ADDRESS);
    }
  }, {
    key: "isEditFlow",
    value: function isEditFlow() {
      return this.orderScenario === ORDER_SCENARIOS.CHANGE_ORDER || this.orderScenario === ORDER_SCENARIOS.TRANSITION_OFFER;
    }
  }, {
    key: "showOrderDetails",
    value: function showOrderDetails() {
      return !this.transferFromSubscriberId && (this.orderScenario === ORDER_SCENARIOS.NEW_CONNECT || this.orderScenario === ORDER_SCENARIOS.CHANGE_ORDER || this.orderScenario === ORDER_SCENARIOS.ADD_OFFER);
    }
  }, {
    key: "supportsInvoiceOptions",
    value: function supportsInvoiceOptions() {
      return this.isEditFlow() && !this.state.isDbss;
    }
  }, {
    key: "setCountryData",
    value: function setCountryData() {
      if (this.billingAddress.Country) {
        var payload = {
          Country: this.billingAddress.Country
        };
        this.actions.setAddressData(payload);
      } else {
        // Have to apply this here due to the previous step in New Connect not needing to reset the redux store yet
        this.actions.setAddressData(null);
      }
    }
  }, {
    key: "handleItemDownPaymentChanged",
    value: function handleItemDownPaymentChanged(itemIndex, item) {
      var isDownPaymentOptionChanged = this.financedItems[itemIndex].isFullPriceDownPaymentSelected !== item.isFullPriceDownPaymentSelected;
      if (isDownPaymentOptionChanged && isNil(item.downPayment)) {
        item.downPayment = item.minimumDownPayment;
      }
      if (!isNil(item.downPayment) && this.financedItems[itemIndex].downPayment !== item.downPayment || isDownPaymentOptionChanged) {
        this.isFinancedItemsModified = true;
        this.itemDownPayment = item;
      }
    }
  }, {
    key: "handlePaymentTypeChange",
    value: function handlePaymentTypeChange() {
      this.paymentInstrument = Object.assign(cloneDeep(BLANK_PAYMENT_INSTRUMENT_CHECKOUT_AUTO_PAY), {
        Type: this.paymentInstrument.Type
      });
      var newPaymentInstrumentObject = this.buildPaymentInstrumentObject();
      this.updatePaymentInfo()(newPaymentInstrumentObject);
    }
  }, {
    key: "updateSubscriberProductIds",
    value: function updateSubscriberProductIds(pricingPlanId, productId, offeringInstanceId, options) {
      var _this3 = this;
      this.renewalData[offeringInstanceId][pricingPlanId]['pricingPlanId'] = pricingPlanId;
      this.renewalData[offeringInstanceId][pricingPlanId]['productId'] = productId;
      var matchingOption = options.find(function (option) {
        return option.SubscriberProductId === _this3.renewalData[offeringInstanceId][pricingPlanId]['subscriberProductId'];
      });
      if (matchingOption) {
        this.renewalData[offeringInstanceId][pricingPlanId]['nextRenewalDate'] = matchingOption.NextRenewalDate;
      } else {
        this.renewalData[offeringInstanceId][pricingPlanId]['nextRenewalDate'] = undefined;
        this.renewalData[offeringInstanceId][pricingPlanId]['subscriberProductId'] = undefined;
      }
    }
  }, {
    key: "updateSelectedDeliveryMethod",
    value: function updateSelectedDeliveryMethod(deliveryMethod) {
      return this.deliveryDecisionWithCost = this.deliveryMethodOptions.find(function (item) {
        return item.value === deliveryMethod;
      });
    }
  }, {
    key: "updateSelectedShippingAddress",
    value: function updateSelectedShippingAddress() {
      this.updateShippingDetails();
      this.closeChangeShippingAddressPopup();
    }
  }, {
    key: "handleIsAutoPayActiveChanged",
    value: function handleIsAutoPayActiveChanged() {
      this.paymentInstrument.Type = null;
      this.handlePaymentInstrumentChanged();
    }
  }, {
    key: "validatePaymentObject",
    value: function validatePaymentObject(paymentInstrument) {
      if (paymentInstrument.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD) {
        var cardObject = paymentInstrument.CreditCard;
        return cardObject.NameOnCard && cardObject.Type && cardObject.AccountNumber && cardObject.ExpirationMonth && cardObject.ExpirationYear;
      }
      return true;
    }
  }, {
    key: "handlePaymentInstrumentChanged",
    value: function handlePaymentInstrumentChanged() {
      this.setCountryData();
      if (this.newPaymentInstrument) {
        if (this.isAutoPayActive && !pathOr(0, ['Type', 'length'], this.paymentInstrument) && this.state.paymentInstrumentsWithAutoPay.length) {
          this.savePaymentInstrument = true;
          this.actions.setRecordPaymentInstrument(this.savePaymentInstrument);
          this.paymentInstrument.Type = this.state.paymentInstrumentsWithAutoPay[0].paymentInstrumentType.Value;
        } else if (!this.isAutoPayActive && !pathOr(0, ['Type', 'length'], this.paymentInstrument) && this.state.paymentInstrumentTypeValueOptions.length) {
          this.savePaymentInstrument = true;
          this.actions.setRecordPaymentInstrument(this.savePaymentInstrument);
          this.paymentInstrument.Type = this.state.paymentInstrumentTypeValueOptions[0].paymentInstrumentType.Value;
        } else if (!this.isAutoPayActive && !this.isPaymentInstrumentRequired && !this.supplyPaymentInstrument && !this.hasDownPaymentItemsChanges()) {
          this.supplyPaymentInstrument = false;
          this.serviceAddressAsBillingAddress = false;
          this.paymentInstrument = Object.assign(cloneDeep(BLANK_PAYMENT_INSTRUMENT_CHECKOUT_AUTO_PAY), {
            Type: this.state.paymentInstrumentTypeValueOptions.length ? this.state.paymentInstrumentTypeValueOptions[0].paymentInstrumentType.Value : BLANK_PAYMENT_INSTRUMENT_CHECKOUT_AUTO_PAY.Type
          });
          this.billingAddress = cloneDeep(BLANK_BILLING_ADDRESS_NEW);
        }
        var creditCardForm = this.paymentInstrumentForm['creditCardController.creditCardForm'];
        var shouldRecalculate = this.newPaymentInstrument && creditCardForm && creditCardForm.$valid && !this.state.isDbss && (this.serviceAddressAsBillingAddress || !isEmpty(this.addressFormModel) && !isEmpty(this.addressFormModel['country']) && !isEmpty(this.addressFormModel['addressLine1']) && !isEmpty(this.addressFormModel['postalCode']));
        var newPaymentInstrumentObject = this.buildPaymentInstrumentObject();
        this.updatePaymentInfo()(newPaymentInstrumentObject);
        if (shouldRecalculate && this.validatePaymentObject(newPaymentInstrumentObject)) {
          this.callRecalculateQuote(newPaymentInstrumentObject);
        }
      }
      this.actions.supplyPaymentInstrument(this.supplyPaymentInstrument || this.isAutoPayActive);
    }
  }, {
    key: "handleSavePaymentInstrumentChanged",
    value: function handleSavePaymentInstrumentChanged() {
      this.actions.setRecordPaymentInstrument(this.savePaymentInstrument);
      if (!this.savePaymentInstrument) {
        this.isAutoPayActive = false;
        this.handlePaymentInstrumentChanged();
      }
    }
  }, {
    key: "onAddressFormUpdate",
    value: function onAddressFormUpdate(addressFormModel) {
      this.billingAddress.LineOne = addressFormModel.addressLine1;
      this.billingAddress.LineTwo = addressFormModel.addressLine2;
      this.billingAddress.City = addressFormModel.city;
      this.billingAddress.Country = addressFormModel.country;
      this.billingAddress.State = addressFormModel.stateRegionProvince;
      this.billingAddress.PostalCode = addressFormModel.postalCode;
      this.addressFormModel.addressLine1 = addressFormModel.addressLine1;
      this.addressFormModel.addressLine2 = addressFormModel.addressLine2;
      this.addressFormModel.city = addressFormModel.city;
      this.addressFormModel.country = addressFormModel.country;
      this.addressFormModel.stateRegionProvince = addressFormModel.stateRegionProvince;
      this.addressFormModel.postalCode = addressFormModel.postalCode ? addressFormModel.postalCode : null;
      this.handlePaymentInstrumentChanged();
    }
  }, {
    key: "hasAddress",
    value: function hasAddress() {
      var billingAddress = this.billingAddress && !!this.billingAddress.LineOne;
      var customerAddress = this.customer && !!this.customer.addressLine1;
      return this.serviceAddress || billingAddress || customerAddress;
    }
  }, {
    key: "callRecalculateQuote",
    value: function callRecalculateQuote() {
      var paymentInstrument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (this.recalculateQuote) {
        this.recalculateQuote()(paymentInstrument);
      }
    }
  }, {
    key: "updatePurchaseOrderNumber",
    value: function updatePurchaseOrderNumber() {
      this.actions.setPurchaseOrderNumber(this.purchaseOrderNumber);
    }
  }, {
    key: "changesEffectiveChanged",
    value: function changesEffectiveChanged() {
      this.actions.setChangesEffective(this.changesEffectiveSelection);
      this.callRecalculateQuote();
    }
  }, {
    key: "updateExternalContractId",
    value: function updateExternalContractId() {
      this.actions.setExternalContractId(this.externalContractId);
    }
  }, {
    key: "onExecutionOptionChange",
    value: function onExecutionOptionChange(executionOptionsModel) {
      this.executionOptionsModel = executionOptionsModel;
    }
  }, {
    key: "onFdoFormValidityChange",
    value: function onFdoFormValidityChange(message) {
      this.fdoErrorMessageFromComponent = message;
      return message;
    }
  }, {
    key: "doErrorsExistOnFdoForm",
    value: function doErrorsExistOnFdoForm(isFormValid) {
      this.errorsExistOnForm = isFormValid;
      return isFormValid;
    }
  }, {
    key: "editPurchaseOrderNumber",
    value: function editPurchaseOrderNumber() {
      this.purchaseOrderNumberReadOnly = false;
    }
  }, {
    key: "removePurchaseOrderNumber",
    value: function removePurchaseOrderNumber() {
      this.purchaseOrderNumberReadOnly = false;
      this.purchaseOrderNumber = null;
      this.updatePurchaseOrderNumber();
    }
  }, {
    key: "editExternalContractId",
    value: function editExternalContractId() {
      this.externalContractIdReadOnly = false;
    }
  }, {
    key: "removeExternalContractId",
    value: function removeExternalContractId() {
      this.externalContractIdReadOnly = false;
      this.externalContractId = null;
      this.updateExternalContractId();
    }
  }, {
    key: "_updateBillCycle",
    value: function _updateBillCycle(billCycle) {
      this.updateBillCycle()(billCycle);
    }
  }, {
    key: "showDownPaymentsSchedulingAndBilling",
    value: function showDownPaymentsSchedulingAndBilling() {
      return this.financedItems.length && this.displaySummaryTab && !this.isDevicePaymentsHidden || this.state.isDbss && this.isOrderPostPaid && this.cartHasOfferWithBillerRuleCycleLevelOtherThanItem() || this.canShowFdoAndBed() && (this.showFDO() || this.isBillingEffectiveDateShown());
    }
  }, {
    key: "showEditDownPayments",
    value: function showEditDownPayments() {
      return this.financedItems.length && !this.isDevicePaymentsHidden;
    }
  }, {
    key: "showEditSchedulingAndBilling",
    value: function showEditSchedulingAndBilling() {
      return this.isFirstOrder() && !this.isBillCycleEditDisabled || this.canShowFdoAndBed() && (this.showFDO() || this.isBillingEffectiveDateShown());
    }
  }, {
    key: "canShowFdoAndBed",
    value: function canShowFdoAndBed() {
      return this.state.isDbss && this.isOrderPostPaid && this.state.fdoAllowedInBunt && !this.isReconnectOffer && this.displaySummaryTab;
    }
  }, {
    key: "showFDO",
    value: function showFDO() {
      return this.hasInvoiceItems && !this.transferFromSubscriberId && this.cartHasOfferWithBillerRuleCycleLevelOtherThanItem() || !this.transferFromSubscriberId;
    }
  }, {
    key: "showPaymentInfoSection",
    value: function showPaymentInfoSection() {
      return this.isOrderPostPaid && !this.newPaymentInstrument && this.hasOffCycleChargeRenewal && this.state.selectedPaymentMethod && !this.state.selectedPaymentMethod.Default || !this.newPaymentInstrument;
    }
  }, {
    key: "getBillCycleOptions",
    value: function getBillCycleOptions() {
      var _this4 = this;
      return (this.getCandidateBillCycles() || []).map(function (billCycle) {
        return Object.assign(cloneDeep(billCycle), {
          text: billCycle.name,
          selected: _this4.selectedBillCycle && _this4.selectedBillCycle.id === billCycle.id,
          subtextList: [i18n.translate(CustomerCareKeys.BILL_CYCLE.NEXT_BILL_DATE, {
            next_bill_date: _this4.$filter('localShortDate')(billCycle.billDate)
          }), i18n.translate(CustomerCareKeys.BILL_CYCLE.PAYMENT_DUE_DATE, {
            payment_due_date: _this4.$filter('localShortDate')(billCycle.paymentDueDate)
          })]
        });
      });
    }
  }, {
    key: "onBillCycleSelectOptionSelected",
    value: function onBillCycleSelectOptionSelected(selectedOption) {
      this.billCycleOptions.forEach(function (billCycleOption) {
        billCycleOption.selected = false;
      });
      selectedOption.selected = true;
      this.editedBillCycle = selectedOption;
    }
  }, {
    key: "getSelectedFdoDisplayText",
    value: function getSelectedFdoDisplayText() {
      var executionOptions = this.state.executionOptions || {};
      switch (+executionOptions.effective) {
        case SCHEDULED_ORDER_OPTIONS.EFFECTIVE_IMMEDIATELY:
          return i18n.translate(this.customerCareKeys.SCHEDULING_OPTIONS.EFFECTIVE_IMMEDIATELY);
        case SCHEDULED_ORDER_OPTIONS.ON_NEXT_BILL_CYCLE:
          return i18n.translate(this.customerCareKeys.SCHEDULING_OPTIONS.ON_NEXT_BILL_CYCLE);
        case SCHEDULED_ORDER_OPTIONS.ON_SPECIFIED_DATE:
          return executionOptions.specifiedDateFromPicker || executionOptions.specifiedDate ? this.$filter('localShortDate')(executionOptions.specifiedDateFromPicker || executionOptions.specifiedDate) : '';
        default:
          return '';
      }
    }
  }, {
    key: "getSelectedBedDisplayText",
    value: function getSelectedBedDisplayText() {
      var executionOptions = this.state.executionOptions || {};
      switch (+executionOptions.billingEffectiveIntention) {
        case BILLING_EFFECTIVE_DATE_ORDER_OPTIONS.ON_ORDER_COMPLETION:
          return i18n.translate(this.customerCareKeys.SCHEDULING_OPTIONS.BILLING_EFFECTIVE_DATE.BILLING_EFFECTIVE_DATE_1);
        case BILLING_EFFECTIVE_DATE_ORDER_OPTIONS.ON_LAST_ORDER:
          return i18n.translate(this.customerCareKeys.SCHEDULING_OPTIONS.BILLING_EFFECTIVE_DATE.BILLING_EFFECTIVE_DATE_2);
        case BILLING_EFFECTIVE_DATE_ORDER_OPTIONS.ON_SPECIFIED_DATE:
          return executionOptions.billingEffectiveDate ? this.$filter('shortWithSeconds')(executionOptions.billingEffectiveDate) : '';
        case BILLING_EFFECTIVE_DATE_ORDER_OPTIONS.ON_NEXT_BILL_CYCLE:
          return i18n.translate(this.customerCareKeys.SCHEDULING_OPTIONS.BILLING_EFFECTIVE_DATE.BILLING_EFFECTIVE_DATE_4);
        default:
          return '';
      }
    }
  }, {
    key: "updateShippingDetails",
    value: function updateShippingDetails() {
      this.shipToName = this.state.updatedShippingAddress && this.state.updatedShippingAddress.ShipToName || this.formattedName;
      var shippingDetails = {
        methodId: this.deliveryDecisionWithCost && this.deliveryDecisionWithCost.value,
        shipTo: this.shipToName
      };
      if (this.state.updatedShippingAddress && !this.state.updatedShippingAddress.Id) {
        var shippingAddress = cloneDeep(this.state.updatedShippingAddress);
        shippingAddress.Name = this.shipToName;
        shippingDetails.address = _objectSpread(_objectSpread({}, shippingAddress), {}, {
          DefaultService: true
        });
        shippingDetails.addressId = this.state.updatedShippingAddress.Id;
      } else {
        shippingDetails.addressId = this.state.updatedShippingAddress.Id;
      }
      this.actions.updateShippingDetails(shippingDetails);
    }
  }, {
    key: "onSubmitEditModal",
    value: function onSubmitEditModal(executionOptionsModel) {
      var _this$deliveryDecisio,
        _this5 = this;
      this.showErrorSummary = true;
      this.selectedBillCycle = this.editedBillCycle;
      this.executionOptionsModel = executionOptionsModel;
      this.actions.setExecutionOptions(this.executionOptionsModel);
      if (this.isFinancedItemsModified) {
        this.actions.setDevicePaymentOptions(this.edit.financedItems);
        if (this.onItemDownpaymentChanged && this.itemDownPayment) {
          this.onItemDownpaymentChanged()(this.itemDownPayment);
        }
      }
      if (this.selectedBillCycle) {
        this._updateBillCycle(this.selectedBillCycle.name);
      }
      if (this.isShippingRequired && this.shippingAddress || (_this$deliveryDecisio = this.deliveryDecisionWithCost) !== null && _this$deliveryDecisio !== void 0 && _this$deliveryDecisio.value) {
        this.updateShippingDetails();
      }
      if (this.orderScenario === ORDER_SCENARIOS.NEW_CONNECT && this.initialBillcycleId !== this.selectedBillCycle.id) {
        this.initialBillcycleId = this.selectedBillCycle.id;
        this.actions.updateSubscriberBillCycle(this.selectedBillCycle.id, this.state.customerInfoNewConnect.Id).then(function () {
          _this5.fetchQuote(!_this5.state.currentCustomerId, _this5.shippingDetails);
        });
      } else if (this.orderScenario === ORDER_SCENARIOS.ADD_OFFER) {
        this.fetchQuote(!this.state.currentCustomerId, this.shippingDetails);
      } else {
        this.callRecalculateQuote([]);
      }
      this.closeEditCheckoutPageInformationPopup();
    }
  }, {
    key: "shouldShowBillingAddress",
    value: function shouldShowBillingAddress() {
      return this.newPaymentInstrument && (this.isPaymentInstrumentRequired || this.supplyPaymentInstrument || this.isOrderPostPaid && this.isAutoPayActive) || this.hasDownPaymentItemsChanges();
    }
  }, {
    key: "shouldShowPaymentMethod",
    value: function shouldShowPaymentMethod() {
      return !this.isPaymentInstrumentRequired && !this.isExternallyManagedArCustomer && !(this.isOrderPostPaid && this.state.isAutoPayEnabled && this.state.isDbss) && this.hasNoPaymentInstruments();
    }
  }, {
    key: "shouldShowPaymentMethodAutoPay",
    value: function shouldShowPaymentMethodAutoPay() {
      return this.state.isAutoPayEnabled && this.isOrderPostPaid && this.state.isDbss && this.hasNoPaymentInstruments();
    }
  }, {
    key: "shouldShowPaymentMethodAutoPayAdd",
    value: function shouldShowPaymentMethodAutoPayAdd() {
      return this.state.isAutoPayEnabled && this.isOrderPostPaid && this.state.isDbss && !this.hasNoPaymentInstruments();
    }
  }, {
    key: "shouldShowSaveForFutureUseField",
    value: function shouldShowSaveForFutureUseField() {
      return this.newPaymentInstrument && this.isPaymentInstrumentRequired || this.supplyPaymentInstrument || this.isAutoPayActive || this.hasDownPaymentItemsChanges();
    }
  }, {
    key: "shouldShowAutopayPaymentTypeField",
    value: function shouldShowAutopayPaymentTypeField() {
      return this.newPaymentInstrument && this.isPaymentInstrumentRequired || this.supplyPaymentInstrument || this.isOrderPostPaid && this.isAutoPayActive || this.hasDownPaymentItemsChanges();
    }
  }, {
    key: "shouldShowAutopayNoPaymentInstruments",
    value: function shouldShowAutopayNoPaymentInstruments() {
      return this.isAutoPayActive && this.shouldShowPaymentMethod();
    }
  }, {
    key: "shouldShowPaymentInstrumentForm",
    value: function shouldShowPaymentInstrumentForm() {
      return this.newPaymentInstrument && this.isPaymentInstrumentRequired || this.supplyPaymentInstrument || this.isOrderPostPaid && this.isAutoPayActive || this.hasDownPaymentItemsChanges();
    }
  }, {
    key: "shouldShowPaymentMethodSection",
    value: function shouldShowPaymentMethodSection() {
      return this.newPaymentInstrument && (this.shouldShowPaymentMethodAutoPay() || this.shouldShowSaveForFutureUseField() || this.shouldShowAutopayPaymentTypeField() || this.shouldShowAutopayNoPaymentInstruments() || this.shouldShowPaymentInstrumentForm() || this.hasDownPaymentItemsChanges());
    }
  }, {
    key: "hasNoPaymentInstruments",
    value: function hasNoPaymentInstruments() {
      return !this.state.selectedPaymentMethod;
    }
  }, {
    key: "onListUpdated",
    value: function onListUpdated() {
      this.onAdditionalPropertyListUpdated()();
    }
  }, {
    key: "onOfferAdditionalPropertyListUpdated",
    value: function onOfferAdditionalPropertyListUpdated() {
      this.onAdditionalPropertyListUpdated()(true);
    }
  }, {
    key: "onPropertyChanged",
    value: function onPropertyChanged(id, newValue) {
      this.onAdditionalPropertyChanged()(id, newValue);
    }
  }, {
    key: "onOfferAdditionalPropertyChanged",
    value: function onOfferAdditionalPropertyChanged(id, newValue) {
      this.onAdditionalPropertyChanged()(id, newValue, true);
    }
  }, {
    key: "isBillingEffectiveDateShown",
    value: function isBillingEffectiveDateShown() {
      if (!this.state || !this.state.userSecurityAttributes) {
        return false;
      }
      return hasAccess(this.state.userSecurityAttributes, OVERRIDE_BILLING_EFFECTIVE_DATE) && !this.isNewConnect;
    }
  }, {
    key: "handleCreditBreachValidations",
    value: function handleCreditBreachValidations() {
      this.extraErrorMessages = [];
      if (this.shouldShowCreditAndFinanceLimitBreaches()) {
        this.extraErrorMessages.push(i18n.translate(this.customerCareKeys.FINANCE_AND_CREDIT_LIMIT_BREACHED_NOTICE));
      }
      if (this.shouldShowCreditLimitBreached()) {
        this.extraErrorMessages.push(this.breachedCreditLimit);
      }
      if (this.shouldShowFinanceLimitBreached()) {
        this.extraErrorMessages.push(this.breachedFinanceLimit);
      }
    }
  }, {
    key: "getFilteredReasonCodes",
    value: function getFilteredReasonCodes() {
      var orderTypeFilter = this.isEditFlow() ? ORDER_TYPE_CODE.CHANGE_OF_SERVICE : ORDER_TYPE_CODE.NEW;
      return (Object.values(this.state.reasonCodes) || []).filter(function (code) {
        var _code$AdditionalPrope;
        return (code === null || code === void 0 ? void 0 : (_code$AdditionalPrope = code.AdditionalProperties) === null || _code$AdditionalPrope === void 0 ? void 0 : _code$AdditionalPrope.order_type_code) === +orderTypeFilter;
      });
      ;
    }
  }]);
}();
export var CheckoutComponent = {
  template: require('./checkout.html'),
  controller: CheckoutController,
  bindings: {
    additionalPropertiesCollection: '<',
    additionalPropertyValueOptions: '<',
    addressStates: '<',
    availableCredit: '<?',
    availableFinanceCredit: '<?',
    billingEffectiveDate: '<?',
    customer: '<',
    displaySummaryTab: '<?',
    deliveryMethodOptions: '<?',
    fetchOrderQuote: '&?',
    fetchQuoteNewConnect: '&?',
    financedItems: '<?',
    formattedCityState: '<',
    formattedName: '<',
    hasInvoiceItems: '<',
    hasOffCycleChargeRenewal: '<?',
    hideOfferAdditionalProperties: '<?',
    isCreatingOrUpdatingCustomer: '<',
    isBillCycleEditDisabled: '<?',
    isDevicePaymentsHidden: '<?',
    isDevicePaymentsDisabled: '<?',
    isCreditLimitBreached: '<?',
    isExternallyManagedArCustomer: '<',
    isFetchingData: '<',
    isModifyingPurchaseOrderNumberDisabled: '<?',
    isNewConnect: '<?',
    isOrderPostPaid: '<',
    isPaymentInstrumentRequired: '<',
    isReconnectOffer: '<?',
    isShippingRequired: '<?',
    offerAdditionalPropertiesCollection: '<',
    onAdditionalPropertyListUpdated: '&',
    onAdditionalPropertyChanged: '&',
    onItemDownpaymentChanged: '&?',
    orderId: '<?',
    orderScenario: '<',
    paymentInfo: '<',
    recalculateQuote: '&?',
    savePaymentInstrument: '<',
    serviceAddress: '<',
    shippingAddress: '<?',
    shippingAddressDropdownOptions: '<?',
    showAlignRenewals: '<?',
    transferFromSubscriberId: '<?',
    updateBillCycle: '&',
    updatePaymentInfo: '&',
    onCheckoutStepSubmit: '&'
  },
  require: {
    wizardForm: '^form'
  }
};